import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useSecurityStatus } from '../../hooks/security';
import { getOperatorId, handleChange, handleError, trimField } from '../Shared/Functions';
import { AccessTokenVService, MeVService } from '../../services/V2/keymaster';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export function PasswordUpdateModal({ show, onHide, fail, success }) {
    const { user } = useSecurityStatus();
    const [newUser, setNewUser] = useState<any>();
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [showNewPassword, setShowNewPassword] = useState<boolean>(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);

    const resetHide = () => {
        setIsSubmitting(false)
        setNewUser(null);
        onHide();
    }
    
    const submit = async () => {
        setIsSubmitting(true)
        let opId: any = await getOperatorId();
        AccessTokenVService
            .accessTokenVCreateAccessToken({
                username: user.username,
                password: newUser.password,
                operatorId: opId
            })
            .then(token => {
                getOperatorId()
                    .then((x:any) =>{
                        MeVService.meVUpdateMe({
                                password: newUser.newPassword
                            })
                            .then(() => {
                                success("Password Updated")
                                resetHide()
                                setIsSubmitting(false)
                            })
                            .catch(err => {
                                err.message !=="Not Found" && fail(handleError(err))
                                setIsSubmitting(false)
                    })
                    })
            })
            .catch(err => {
                err.message !=="Not Found" && fail(handleError(err))
                setIsSubmitting(false)}
            )
    }

    return <>
        <Dialog open={show} onClose={resetHide}>
            <DialogTitle>Change Password</DialogTitle>
            <DialogContent>
                {isSubmitting ?
                    <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div>
                    : <form>
                        <div><b>Password must contain at least 8 characters, 1 capital letter, 1 number, and 1 special character from the following list:</b></div>
                        <div><b>{"# ? ! @ $ % ^ & + = < > ( ) _ { } ` , | [ ] - \\"}</b></div>
                        <TextField
                            onChange={e => handleChange(e, newUser, setNewUser)}
                            onBlur={e => trimField(e, newUser, setNewUser)}
                            margin="normal"
                            name="password"
                            label="Current Password"
                            type={showPassword ? 'text' : 'password'}
                            autoComplete="current-password"
                            value={newUser?.password}
                            fullWidth
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => setShowPassword(!showPassword)}
                                            onMouseDown={e => e.preventDefault()}
                                            edge="end"
                                            >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                        <TextField
                            onChange={e => handleChange(e, newUser, setNewUser)}
                            onBlur={e => trimField(e, newUser, setNewUser)}
                            margin="normal"
                            name="newPassword"
                            label="New Password"
                            type={showNewPassword ? 'text' : 'password'}
                            autoComplete="new-password"
                            value={newUser?.newPassword}
                            fullWidth
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => setShowNewPassword(!showNewPassword)}
                                            onMouseDown={e => e.preventDefault()}
                                            edge="end"
                                            >
                                            {showNewPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                        <TextField
                            onChange={e => handleChange(e, newUser, setNewUser)}
                            onBlur={e => trimField(e, newUser, setNewUser)}
                            margin="normal"
                            name="confirmPassword"
                            label="Confirm Password"
                            type={showConfirmPassword ? 'text' : 'password'}
                            autoComplete="new-password"
                            value={newUser?.confirmPassword}
                            error={newUser?.newPassword !== newUser?.confirmPassword}
                            fullWidth
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            onMouseDown={e => e.preventDefault()}
                                            edge="end"
                                            >
                                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </form>}
            </DialogContent>
            <DialogActions className='user-info-buttons-group'>
                <>
                    <Button variant="outlined" onClick={resetHide} style={{marginRight:"10px"}}>Cancel</Button>
                    <Button variant="contained" onClick={submit}>Save</Button>
                </>
            </DialogActions>
        </Dialog>
    </>
}
